import { IBoardDto } from '../model/IBoardDto';
import { axiosMod, getPublicApiUrl } from '../utility';

export interface IBoardApi {
  getById(id: number): Promise<IBoardDto>;
}

export class BoardApi implements IBoardApi {
  private endpointUrl: string;

  constructor() {
    this.endpointUrl = getPublicApiUrl('/board');
  }

  async getById(id: number): Promise<IBoardDto> {
    const response = await axiosMod().get<IBoardDto>(
      `${this.endpointUrl}/${id}`
    );

    return response.data;
  }
}
